// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
// import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader"; // Store Custom Code
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import useLinkBackParameter from "@toolkit/Framework/Common/Hooks/useLinkBackParameter";
// import React, { FC } from "react"; // Store Custom Code
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

/* Store Custom Code - Start */
import React, { FC, useRef } from "react";
import objectKeys from "@store/Framework/Common/Utilities/objectKeys";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
/* Store Custom Code - End */

const OrderCancelNotification = getWidgetComponent("OrderDetails/OrderCancelNotification");

export interface OrderDetailsHeaderProps extends WidgetProps {}

export interface OrderDetailsHeaderStyles {}

export const orderDetailsHeaderStyles: OrderDetailsHeaderStyles = {};

const styles = orderDetailsHeaderStyles;

const OrderDetailsHeader: FC<OrderDetailsHeaderProps> = ({ id }) => {
    const orderSearchFilters = useAppSelector(state => state.greif.pages.orderHistory.parameter); // Store Custom Code
    const currentPage = useCurrentPage();
    const baseLinkBack = usePageLinkByPageType(constants.pageType.orderHistory);
    /* Store Custom Code - Start */
    const queryParamsRef = useRef<string | null>(null);

    if (queryParamsRef.current === null) {
        const searchParams = new URLSearchParams();
        objectKeys(orderSearchFilters)?.forEach(key => {
            const val = orderSearchFilters[key];
            if (val !== null && val !== undefined) {
                searchParams.append(key, String(val));
            }
        });
        queryParamsRef.current = searchParams.toString();
    }

    const linkBack = baseLinkBack
        ? {
              ...baseLinkBack,
              url: `${baseLinkBack?.url}${queryParamsRef.current ? `?${queryParamsRef.current}` : ""}`,
          }
        : undefined;
    /* Store Custom Code - End */

    return (
        <OrderHeader
            title={currentPage.fields.title}
            linkBack={linkBack}
            message={<OrderCancelNotification />}
            // Store Custom Code
            isV2
        >
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsHeader,
    definition: {
        group: "Order Details",
        displayName: "Header",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
